import { List, ListItem, ListItemText, ListSubheader, TextField, withStyles } from '@material-ui/core';
import { makeStyles } from "@material-ui/styles";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import clsx from 'clsx';
import _ from "lodash";
import React, { useState } from 'react';
import { AiOutlineFolder } from "react-icons/ai";
import { MdAdd, MdLabel } from "react-icons/md";

const styles = theme => ({
    item: {
        height: 40,
        borderRadius: '0 20px 20px 0',
        paddingRight: 12,
        '&.novo': {
            fontWeight: 700
        },
        '&.active': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText + '!important',
            transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
            '& .list-item-text-primary': {
                color: 'inherit'
            },
            '& .list-item-icon': {
                color: 'inherit'
            }
        },
        '& .list-item-icon': {},
        '& .list-item-text': {},
        backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#fafafa',
        color: theme.palette.text.primary,
        textDecoration: 'none!important',
        border: 0
    },
    itemTag: {
        height: 32,
        borderRadius: '0 20px 20px 0',
        paddingRight: 12,
        margin: '2px 0',
        '&.active': {
            backgroundColor: `${theme.palette.secondary.main}ba`,
            color: theme.palette.secondary.contrastText + '!important',
            transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
            '& .list-item-text-primary': {
                color: 'inherit'
            },
            '& .list-item-icon': {
                color: 'inherit'
            }
        },
        '& .list-item-icon': {},
        '& .list-item-text': {},
        backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#fafafa',
        color: theme.palette.text.primary,
        textDecoration: 'none!important',
        border: 0
    },
});

const CentralNotificacoesSidebarEsquerda = (props) => {

    const { locais = null, classes, setOpenPainel, parametros, setLocal, setLocalTag, getInsumos } = props;
    const { openPainel = false, idlocal = null, tagsOR = null } = parametros;
    const [showPesquisa, setShowPesquisa] = useState(false);
    const [pesquisa, setPesquisa] = useState("");

    return (
        <div className="flex-auto p-12">
            <XAPPButton
                type="Icon"
                className="p-6"
                variant="contained"
                onClick={() => setOpenPainel(!openPainel)}
                iconProps={"justify-center"}
                icon={"list"}
            />
            {!_.isNull(locais) &&
                <List className="grid row-gap-4">
                    <ListSubheader disableSticky className="flex p-6 leading-normal items-center gap-8">
                        <AiOutlineFolder size={20} />
                        {openPainel && (
                            <div className="w-full flex justify-between items-center">
                                <span className="leading-none mt-2">{"LOCAIS"}</span>
                                {!showPesquisa &&
                                    <XAPPButton
                                        type="Icon"
                                        className="p-6"
                                        variant="contained"
                                        onClick={() => setShowPesquisa(!showPesquisa)}
                                        iconProps={"justify-center"}
                                        icon={"search"}
                                    />
                                }
                            </div>
                        )}
                    </ListSubheader>
                    {showPesquisa &&
                        <div className="flex my-6">
                            <TextField
                                className=""
                                placeholder="Buscar"
                                id="pesquisa"
                                name="pesquisa"
                                value={pesquisa}
                                onChange={ev => setPesquisa(ev.target.value)}
                                fullWidth
                            />
                            <XAPPButton
                                type="Icon"
                                className="p-6"
                                variant="contained"
                                onClick={() => {
                                    getInsumos([{ "Campo": "nome", "Operador": "LIKE", "Valor": "%" + pesquisa + "%" }]);
                                    setShowPesquisa(!showPesquisa);
                                    setPesquisa("");
                                }}
                                iconProps={"justify-center"}
                                icon={"search"}
                            />
                        </div>
                    }
                    {locais.map((item) => (
                        <React.Fragment>
                            <ListItem
                                button
                                className={clsx(classes.item, 'list-item', 'list-item-icon', (openPainel && idlocal === item.idlocal && 'active'), item.lido === 0 && "novo")}
                                key={item.idlocal}
                                onClick={() => setLocal(item.idlocal)}
                            >
                                {openPainel &&
                                    <ListItemText className="capitalize" secondary={item.nome.length > 20 ? (item.nome.substring(0, 20) + ".") : item.nome} disableTypography={true} />
                                }
                            </ListItem>
                            {openPainel && idlocal === item.idlocal && !_.isUndefined(item.tags) && !_.isNull(item.tags) && item.tags.map(tag => (
                                <ListItem
                                    button
                                    key={"Tag_" + tag.idtag}
                                    className={clsx(classes.itemTag, 'list-item', 'list-item-icon', !_.isNull(tagsOR) && tagsOR.includes(tag.idtag) && 'active')}
                                    onClick={() => setLocalTag("tagsOR", tag.idtag)}
                                >
                                    <MdLabel className="list-item-icon text-16" color="action" />
                                    <ListItemText primary={tag.nome} disableTypography={true} />
                                </ListItem>
                            ))}
                        </React.Fragment>
                    ))}
                </List>
            }
        </div >
    );
}

export default withStyles(styles, { withTheme: true })(CentralNotificacoesSidebarEsquerda);